import { CategoryLists } from '@/models/CategoryKey';

export const ModelKey = {
	ref_cube_01: 'ref_cube_01_BookShelf',
	ref_cube_02: 'ref_cube_02_DeskShelf',
	ref_cube_03: 'ref_cube_03_WineRackDog',
	ref_cube_04: 'ref_cube_04_WineRack'
};

export default {
	categoryKey: CategoryLists.Refrigerator.list.ref_cube,
	cover: {
		caption: 'LandingPage.ref_cube',
		backgroundImage: require('../../cover_image/small_animals_all.jpg'),
		mobileCoverImage: require('../../cover_image/small_animals_all.jpg'),
		mainImage: {
			src: require('../../../assets/categories/ref_cube.png'),
			pcSrc: require('../../../assets/categories/ref_cube.png'),
		},
	},
	box: {
		title: 'ProductPage.selectDesign', //i18n
		list: [
			{
				key: ModelKey.ref_cube_04,
				image: {
					mobile: require('../../thumbnail/winerack.png'),
					pc: require('../../thumbnail/winerack.png'),
				},
				title: 'ProductPage.WineRack', // i18n
				level: 2,
				minutes: 50,
				allowInches: [],
			},
			{
				key: ModelKey.ref_cube_01,
				image: {
					mobile: require('../../thumbnail/Book_shelf.png'),
					pc: require('../../thumbnail/Book_shelf.png'),
				},
				title: 'ProductPage.BookShelf', // i18n
				level: 2,
				minutes: 60,
				allowInches: [],
			},
			{
				key: ModelKey.ref_cube_02,
				image: {
					mobile: require('../../thumbnail/Desk_shelf.png'),
					pc: require('../../thumbnail/Desk_shelf.png'),
				},
				title: 'ProductPage.DeskShelf', // i18n
				level: 3,
				minutes: 80,
				allowInches: [],
			},
			{
				key: ModelKey.ref_cube_03,
				image: {
					mobile: require('../../thumbnail/winerackdog.png'),
					pc: require('../../thumbnail/winerackdog.png'),
				},
				title: 'ProductPage.WineRackDog', // i18n
				level: 4,
				minutes: 150,
				allowInches: [],
			},
		],
	},
	dezeenBox: {
	},

	worldcup:{
	},
	disney:{},
	ModelKey: ModelKey,
};

export const Boxes = {
	[ModelKey.ref_cube_01]: () => import('./bookshelf'),
	[ModelKey.ref_cube_02]: () => import('./deskshelf'),
	[ModelKey.ref_cube_03]: () => import('./winerackdog'),
	[ModelKey.ref_cube_04]: () => import('./winerack'),
};
